import styled from "styled-components"

import Modal, {Close, Back} from "@irati/ui/src/Modal"
import {H3} from "@irati/ui/src/Typography/Heading"
import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"

const TitleInlineModal = styled(Modal)`
  ${Modal.Inner} {
    padding: ${padding.base}
  }
  ${Close} {
    top: 30px;
    right: 30px;
    ${minWidthMedia.tablet`
      top: 40px;
    `}
  }
  ${Back} {
    top: 25px;
    ${minWidthMedia.tablet`
      top: 35px;
    `}
  }
  ${H3} {
    &:first-of-type {
    ${(props) => props.onBack && `
      margin-left: 20px;
      `}
    }
  }
`

export default TitleInlineModal
